module.exports = __webpack_public_path__ + "fonts/Formular-BoldItalic.f8005b7.woff2";